import { Input, InputProps } from "semantic-ui-react";

type BPInputProps = InputProps & {};

export function BPInput(props: BPInputProps) {
    return <Input {...props}>{props.children}</Input>;
}